module.exports = __webpack_public_path__ + "img/Moon.dff3edcc.svg";